import {Directive, TemplateRef} from '@angular/core';

@Directive({
    selector: '[ostsoMultiSelectBadge]',
    standalone: true
})
export class MultiSelectBadgeDirective<T = any> {

    constructor(public template: TemplateRef<T>) {
    }


}
